export default __webpack_public_path__ + "static/media/no-image.62f2a1d3.png";